import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Typography, Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, TableHead, TableFooter, TablePagination  } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import { Close } from '@mui/icons-material';
import Currency from '../../common/Currency';
import Pagination from '../../../container/MUI/Pagination';
import StackedStats from '../../Stats/StackedStats';
import SpendingDetails from '../../Spendings/SpendingDetails';
import TitleWithEndAction from '../../common/TitleWithEndAction';

class LabelSingle extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        spendings: [],
        total: 0,
    }
    componentDidMount = async () => {
        this.filterSpendings()
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    displayLabels = (labels) => {
        const { LABELS } = this.props;
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name)
    }

    filterSpendings = () => {
        const { SPENDINGS, label } = this.props;
        let filteredList = !isEmpty(SPENDINGS) ? 
        Object.values(SPENDINGS).filter(
            item => {
                let labels = item.spending_labels.split(", ")
                return labels.includes(label.label_id)
            }
        ) : 
        []
        
        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');
        let total = 0
        filteredList.forEach(item => total += item.spending_amount)
        // filteredList.forEach(item => total += item.spending_amountTTC)
        this.setState({
            spendings: filteredList,
            total
        })
    }
    displaySpendings = () => {
        const { rowsPerPage, page, spendings } = this.state;
        const { CATEGORIES, SUPPLIERS, LABELS } = this.props;
        
        return spendings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let category = CATEGORIES.CHILD[item.spending_category]
            // let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            let labels = LABELS && item.spending_labels && this.displayLabels(item.spending_labels)
            let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]

            return (
                <TableRow 
                    hover
                    key={item.spending_id}
                    onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                >
                    <TableCell >
                        {new Date(item.spending_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    <TableCell >{ category && category.category_name}</TableCell>                     
                    <TableCell >{item.spending_desc}</TableCell>   
                    <TableCell >{supplier && supplier.supplier_name}</TableCell>   
                    <TableCell >{labels && labels.join(", ")}</TableCell>   
                    <TableCell ><Currency value={item.spending_amount} /></TableCell>                     
                    {/* <TableCell ><Currency value={item.spending_amountTTC} /></TableCell>                      */}
                    <TableCell >
                        {!item.spending_fully_paid &&
                            <Currency value={item.spending_rest_to_pay} />
                        }
                    </TableCell>                     
                    
                </TableRow>
            )
        })
    }
    render() {
        const { label, CATEGORIES, SUPPLIERS, PAYMENTS, BANKS, LABELS } = this.props;
        const { spendings, rowsPerPage, page, total, selectedSpending, openDetails} = this.state;
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullScreen
                scroll="paper"
            >
                {openDetails && selectedSpending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[selectedSpending.spending_supplier]} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_category]} 
                        spending={selectedSpending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                <AppBar style={{position: 'relative'}} color="secondary">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                            <Close />
                        </IconButton>
                        <Typography variant="h6" color="inherit">
                        {label.label_name}
                        </Typography>
                    </Toolbar>
                </AppBar>
                    
                <DialogContent>
                    <Box>
                        <SwipeableTabs
                            labels={["Statistiques", "Dépenses"]}
                        >
                            <Box p={3}>
                                {/* Total: <Currency value={total} /> */}
                                <StackedStats 
                                    CATEGORIES={this.props.CATEGORIES.CHILD}
                                    SPENDINGS={this.state.spendings}
                                />
                            </Box>
                            <Box p={3}>
                                <TitleWithEndAction
                                    title= " "
                                    action={() => this.props.openFormCustom(this.props.label.label_id)}
                                />
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                        <TableCell>Créé le</TableCell>
                                            <TableCell>Catégorie</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Fournisseur</TableCell>
                                            <TableCell>Labels</TableCell>
                                            <TableCell>Montant HT</TableCell>
                                            <TableCell>Reste à Payer</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!isEmpty(spendings) && !isEmpty(CATEGORIES.CHILD) && this.displaySpendings()}
                                    </TableBody>
                                    {size(spendings) > 10 &&
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 30]}
                                                    labelRowsPerPage="Lignes par Page"
                                                    colSpan={7}
                                                    count={size(spendings)}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    onPageChange={this.handleChangePage}
                                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                    ActionsComponent={Pagination}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    }
                                </Table>
                            </Box>
                        </SwipeableTabs>
                    </Box>
                </DialogContent>
            </Dialog>
        );
    }
}

export default LabelSingle;